var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.32,
    height: 35.32,
    viewBox: "0 0 35.32 35.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168893",
    "data-name": "Path 168893",
    d: "M20.76,17.66l2.93-2.93a1.89,1.89,0,0,0,0-2.66l-.44-.44a1.89,1.89,0,0,0-2.66,0l-2.93,2.93-2.93-2.93a1.89,1.89,0,0,0-2.66,0l-.44.44a1.89,1.89,0,0,0,0,2.66l2.93,2.93-2.93,2.93a1.89,1.89,0,0,0,0,2.66l.44.44a1.89,1.89,0,0,0,2.66,0l2.93-2.93,2.93,2.93a1.89,1.89,0,0,0,2.66,0l.44-.44a1.89,1.89,0,0,0,0-2.66Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168894",
    "data-name": "Path 168894",
    d: "M17.66,4.25A13.41,13.41,0,1,1,4.25,17.66,13.41,13.41,0,0,1,17.66,4.25m0-4.25A17.66,17.66,0,1,0,35.32,17.66,17.66,17.66,0,0,0,17.66,0Z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.c51c24fd1b4c43b35ffde8bed63bbc56.svg";
export { ForwardRef as ReactComponent };